"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reset = void 0;
const styled_components_1 = require("styled-components");
exports.reset = (0, styled_components_1.css) `
  padding: 0;
  margin: 0;
  color: ${({ secondary, theme }) => secondary ? theme.palette.text.secondary : theme.palette.text.default};

  ${({ weight }) => {
    switch (weight) {
        case 'bold':
            return (0, styled_components_1.css) `
          font-weight: 700;
        `;
        case 'semibold':
            return (0, styled_components_1.css) `
          font-weight: 600;
        `;
        case 'medium':
            return (0, styled_components_1.css) `
          font-weight: 500;
        `;
        case 'normal':
            return (0, styled_components_1.css) `
          font-weight: 400;
        `;
        default:
            return ``;
    }
}}
`;
//# sourceMappingURL=typography.js.map